import React from 'react'
import { Typography } from '@mui/material'
import { Box } from '@mui/system'
import LocalPhoneIcon from '@mui/icons-material/LocalPhone'

const stylefooter = {
	width: '100%',
	display: 'flex',
	bgcolor: 'primary.main',
	height: '24px',
	position: 'fixed',
	bottom: '0',
}

export const Footer = () => {
	return (
		<Box sx={stylefooter}>
			<Box sx={{ width: '70%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', ml: 15.7 }}>
				<Typography component={'span'} color='white' fontSize={12}>
					Copyright © 2023 AMAS
				</Typography>
				<Typography component={'span'} sx={{ display: 'flex', alignItems: 'center', color: 'white', fontSize: 12 }}>
					<LocalPhoneIcon fontSize='small' /> 8717
				</Typography>
			</Box>
		</Box>
	)
}
